import { Inject } from '@odinjs/odin';

import { Endpoint, ReportService } from '@philips-emr/hpms-stipulator-commons';
import { Report } from '@philips-emr/hpms-stipulator-components';
import { ActionAPI, FieldAPI, FieldListAPI, FieldsetAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';
import { isEmptyOrBlankString } from '@philips-emr/tws-utils';

import { AutorizacaoGuiaFormAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

interface AutorizacaoData {
  nrSeqSegurado: number;
  cdSenha: string;
  dtValidadeSenha: string;
  nmRecemNascido: string;
  dtNascRecemNascido: string;
  ieTipoGuia: Guia;
  ieStatus: string;
  cdGuia: string;
}

interface Diagnostico {
  cdDoenca: string;
  dsDoenca: string
}

enum Guia {
  SOLICITACAO_INTERNACAO = '1',
  SOLICITACAO_PRORROGACAO_INTERNACAO = '8',
}

const GRUPO_RELATORIO_AUTORIZACAO_GUIA = '11';
@Controller({ fragment: FragmentNames.AUTORIZACAO_GUIA_FORM })
class AutorizacaoGuiaFormController extends BaseController {

  @Inject(Aliases.FIELDSET_EXTERNA)
  private fieldsetExterna: FieldsetAPI;
  @Inject(Aliases.FIELDSET_RECEM_NASCIDO)
  private fieldsetRecemNascido: FieldsetAPI;
  @Inject(Aliases.FIELDSET_INTERNACAO)
  private fieldsetInternacao: FieldsetAPI;
  @Inject(Aliases.FIELD_LIST_CID)
  private fieldListCid: FieldListAPI;
  @Inject(Aliases.FIELD_CID)
  private fieldCid: FieldAPI;
  @Inject(Aliases.ACTION_PRINT)
  private print: ActionAPI;
  private reportService: ReportService;

  @OnMount(Aliases.PANEL_AUTORIZACAO_GUIA_FORM)
  public onMount(): void {
    const { nrSeqGuia } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqGuia });
    this.reportService = new ReportService(GRUPO_RELATORIO_AUTORIZACAO_GUIA, Endpoint.GET.RELATORIOS_AUTORIZACAO_POR_GRUPO);
  }

  @OnClick(Aliases.ACTION_PRINT)
  onClickPrint(): void {
    const { nrSeqGuia } = this.historyService.getCurrentRouteParams();
    this.reportService && this.reportService.abreListaRelatorios({ NR_SEQUENCIA_AUTOR: nrSeqGuia });
  }

  @OnAfterFetch(Aliases.FETCH_CONSULTA)
  public onAfterFetchData(event: FetchEvent): void {
    const data = event.data as AutorizacaoData;

    if (!data) {
      return;
    }

    this.fetchDiagnostico(data.nrSeqSegurado);

    if (isEmptyOrBlankString(data.cdSenha) && isEmptyOrBlankString(data.dtValidadeSenha)) {
      this.fieldsetExterna.setVisible(false);
    }

    if (isEmptyOrBlankString(data.nmRecemNascido) && isEmptyOrBlankString(data.dtNascRecemNascido)) {
      this.fieldsetRecemNascido.setVisible(false);
    }

    if ((data.ieTipoGuia || '').trim() !== Guia.SOLICITACAO_INTERNACAO && (data.ieTipoGuia || '').trim() !== Guia.SOLICITACAO_PRORROGACAO_INTERNACAO) {
      this.fieldsetInternacao.setVisible(false);
    }

    const { nrSeqGuia } = this.historyService.getCurrentRouteParams();

    void this.reportService.getRelatoriosByCdGrupo({ nrSeqGuia, ieTipoGuia: data.ieTipoGuia })
      .then((response: Report[]) => {
        if (response.length === 0) {
          this.print.setEnabled(false);
        }
      });

  }

  private fetchDiagnostico(nrSeqBeneficiario: number): void {
    const { nrSeqContrato, nrSeqGuia } = this.context.getBulkData();

    void HttpService.get<Diagnostico[]>(Endpoint.GET.AUTORIZACAO_DIAGNOSTICO, { nrSeqContrato, nrSeqGuia, nrSeqBeneficiario })
      .then(({ body: response }) => {
        if (!Array.isArray(response)) {
          this.fieldCid.setVisible(false);
          return;
        }

        const list = response.map(dig => ({ diagnostico: `${dig.cdDoenca} - ${dig.dsDoenca}` }));

        if (list.length) {
          this.fieldListCid.setValue(list);
        } else {
          this.fieldCid.setVisible(false);
        }
      });
  }
}

export default {
  AutorizacaoGuiaFormController,
};
